import { Button, SafeArea } from 'antd-mobile'
import classNames from 'classnames'

import { SvgIcon } from '@/components'
import './index.less'
/**
 * 按钮组
 * @returns FC
 */
const Buttons = ({ dataSource, permission }: { dataSource?: any[]; permission?: any }) => {
  const actions = dataSource?.filter((x) => (x.code ? permission?.getCodeFun?.(x.code) : x)) || []
  return (
    actions?.length > 0 && (
      <>
        <div className='unified-page-btns-wrap isFixed'>
          <div className={classNames('unified-page-btns', { justone: dataSource?.length === 1 })}>
            {actions?.map((x, index) => {
              const { icon, onClick, fill, ...rest } = x.elementProps || {}
              return (
                <Button
                  {...x}
                  {...rest}
                  fill={icon ? 'none' : fill}
                  className={classNames(x.className || 'info', {
                    'unified-page-btn-icon': icon
                  })}
                  key={`${x.dataIndex}_${index}`}
                  onClick={() => (onClick || x.onClick)?.(x)}
                >
                  {icon && (
                    <SvgIcon
                      key={`${icon}_${index}`}
                      name={icon}
                      className='unified-page-btn-icon'
                    />
                  )}
                  <span key={`${x.text}_${index}`} className='unified-page-btn-text'>
                    {x.text}
                  </span>
                </Button>
              )
            })}
          </div>
          <SafeArea position='bottom' />
        </div>
        <div className='unified-page-blank' />
      </>
    )
  )
}

export default Buttons
